import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import axios from 'axios';
import { ROOT_URL } from '../../../config/global.js';
import '../../../../styles/scss/style.css';

//Components
import TextHeadingOne from '../../atoms/TextHeadingTwo';
import TextParagraph from '../../atoms/TextParagraph';
import FormButton from '../../atoms/FormButton';
import LabeledTextfield from '../../molecules/LabeledTextfield';
import Modal from '../../organisms/Modal';
import { strings } from './FormCreateSubjectContent';

//Returning the component
class FormCreateSubject extends Component {
	constructor(props) {
		super(props);

		this.state = {
			modalClass: this.props.modalClass,
			currentBot: this.props.currentBot.data,
			updateState: this.props.updateState,
			subjectName: '', // Saves the value of the input field
			selectedSubject: this.props.selectedSubject
		}

		this.createSubject = this.createSubject.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.confirmChange = this.confirmChange.bind(this);
	}
	componentWillReceiveProps(nextProps) {
		// Helps to open and close the pop up
		this.setState({ 
			modalClass: nextProps.modalClass,
			updateState: nextProps.updateState,
			subjectName: nextProps.selectedSubject ? nextProps.selectedSubject.name : '',
			selectedSubject: nextProps.selectedSubject
		});
	}
	createSubject(e) {
		e.preventDefault();
		// Adding loading state to store
		this.props.loading(true);

		// Hide the modal
		this.setState({ modalClass: ''});

		const createSubjectRequest = axios({
			method: 'post',
			url: `${ROOT_URL}/api/subjects`,
			data: {
				botId: this.state.currentBot._id,
				name: this.state.subjectName //Subject name
			}
		});

		// Updates the store with the new login status
		createSubjectRequest.then((subjectReqAnswer) => {
			if (subjectReqAnswer.data) {
				this.props.fetchCurrentBot(this.props.match.params.id);
				
				this.props.loading(false); // Removing loading screen
				
			}
		}).catch((error) => {
			this.setState({ error: error.response });
		});
	}
	updateSubject(e) {
		e.preventDefault();
		// Adding loading state to store
		this.props.loading(true);

		// Hide the modal
		this.setState({ modalClass: '', updateState: '' });

		let newBot = this.state.selectedSubject;
		newBot.name = this.state.subjectName;
		const updateSubjectRequest = axios({
			method: 'put',
			url: `${ROOT_URL}/api/subjects/${this.state.selectedSubject._id}`,
			data: newBot
		});

		// Updates the store with the new login status
		updateSubjectRequest.then((subjectReqAnswer) => {
			if (subjectReqAnswer.data) {
				var newItem = subjectReqAnswer.data;
				newItem.type = 'loaded';
				this.props.setSelectedSubject(newItem); // Clears the selectedSubject with the new one

				this.props.fetchCurrentBot(this.props.match.params.id);

				this.props.loading(false); // Removing loading screen
			}
		}).catch((error) => {
			this.setState({ error: error.response });
		});
	}
	confirmChange(e) {
		// Trigger onBlur, updates the state on auto-fill events
		this.handleChange(e);
	}
	handleChange({ target }) {
		this.setState({
			[target.name]: target.value
		});
	}
	render() {
		return (
			<Modal modalClass={this.state.modalClass}>
				<form className={`form ${this.props.formWrapperClassType}`}>
					<TextHeadingOne text={this.state.updateState ? strings.headingUpdate : strings.heading} />
					<TextParagraph text={strings.paragraph} />
					{/* Subject */}
					<LabeledTextfield 
						formGroupClassType={this.props.formGroupClassType} 
						labelFor="subjectName" 
						labelText="Subject name" 
						labelId="subjectName" 
						textfieldClassType={this.props.textfieldClassType} 
						textfieldId="subjectName" 
						textfieldPlaceholder="Tredan" 
						textfieldName="subjectName" 
						value={this.state.subjectName}
						textfieldForm={this.props.textFieldForm} 
						onChange={this.handleChange}
						onBlur={this.confirmChange}
						errorMessageClassType={this.props.errorMessageClassType} 
						errorMessageText="Invalid name, must contain atleast three characters" 
					/>
					<FormButton text={this.state.updateState ? strings.button.textUpdate : strings.button.text} classType="btn--fullWidth" onClick={this.state.updateState ? (e) =>this.updateSubject(e) : (e) => this.createSubject(e)}/>
				</form>
			</Modal>
		)
	}
}

FormCreateSubject.propTypes = {
	formGroupClassType: PropTypes.string,
	textfieldClassType: PropTypes.string,
	textFieldForm: PropTypes.string,
	textFieldOnChange: PropTypes.string,
	errorMessageClassType: PropTypes.string,
}

export default withRouter(FormCreateSubject);


// WEBPACK FOOTER //
// ./src/redux/components/organisms/FormCreateSubject/FormCreateSubject.jsx